module.exports = __webpack_public_path__ + "img/三人女篮.dea78c49.png";